'use client';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { formatDateStringToLocalVN, mapModifiers } from '@/utils/funtion';
import { IIndicatorItem } from '@/interfaces/indicator';
import { useData } from '@/stores/context';
import Empty from '@/components/atoms/empty';
import Skeleton from '@/components/atoms/skeletons';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '@/components/atoms/icon';
import ChartPackage from '../chartPackage';
import { DATE_FORMAT_DD_MM_YYYY } from '@/utils/dateFormat';
import dayjs from 'dayjs';
import { setDetailUrl } from '@/stores/modules/detailUrl';

export default function HomeIndicatorSummary() {
  const [isLoading, setIsLoading] = useState(true);
  const { indicatorSummary } = useData();

  const userData = useSelector((state: any) => state.userData);
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 400);
  }, []);

  const memoryChart = useCallback(
    (item: any) => {
      return (
        <div className="home-indicator_chart_mini">
          <ChartPackage
            data={
              !item.indicatorValue.length ? item.children : item.indicatorValue
            }
            id={item.id}
            name={''}
            unit={item.unit}
            original={item.original}
            dataType={item.dataType}
            chartType={item.chartType}
            originalUrl={item.originalUrl}
            isStructure={item.isStructure}
            isObjectOneTime={item.isObjectOneTime}
            isTwoUnit={item.isTwoUnit}
            isHiddenHeader
            chartHeight={300}
            captionSize={innerWidth < 500 ? 11 : 13}
            handleClickRangeTime={function (data: any): void {}}
            typeData={item?.type_data}
            parentId={item?.parentId}
          />
        </div>
      );
    },
    [indicatorSummary, isLoading],
  );

  const isLoadingState = isLoading || !indicatorSummary;

  return (
    <div className="home-indicator-summary">
      {isLoadingState ? (
        <HomeIndicatorSummaryLoading />
      ) : !indicatorSummary?.length ? (
        <Empty />
      ) : (
        <div className="home-indicator-summary-list">
          {indicatorSummary.map((item: IIndicatorItem) => {
            const isToday = dayjs(item.updatedAt).isAfter(
              dayjs().subtract(3, 'day'),
            );
            return (
              <a
                key={item.id}
                className={mapModifiers('home-indicator-item')}
                href={`/thong-tin-chi-tiet/${item.slug}/${item.id}?type=${item?.type_data}&structure=${item?.isStructure}&isObjectOneTime=${item?.isObjectOneTime}`}
              >
                <div className="home-indicator_name">{item.name}</div>
                <ul className="home-indicator_desc">
                  <li></li>
                  <li>
                    Ngày cập nhật:{' '}
                    <span>
                      {formatDateStringToLocalVN(
                        item?.updatedAt,
                        DATE_FORMAT_DD_MM_YYYY,
                      )}
                    </span>
                  </li>
                </ul>
                {memoryChart(item)}
                {isToday && (
                  <div className="home-indicator-item_new">
                    <Icon iconName="newest" size="28x28" />
                  </div>
                )}
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
}

function HomeIndicatorSummaryLoading() {
  return (
    <div className="home-indicator-summary">
      <div className="home-indicator-summary-list">
        {Array(6)
          ?.fill(null)
          .map((_, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 18,
                border: '1px solid #f0f0f0',
                padding: 12,
                borderRadius: 6,
                boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)',
              }}
            >
              <Skeleton
                active
                type="input"
                loading
                paragraph={{
                  rows: 0,
                  maxWidth: 1380,
                  width: '100%',
                  fontStyle: 'justify',
                  margin: 0,
                  padding: 0,
                }}
              />
              <Skeleton
                active
                loading
                fullSize
                block
                paragraph={{ rows: 5, maxWidth: 1380, width: '100%' }}
              />
              <Skeleton
                type="node"
                style={{ width: 70, height: 12, marginTop: 0 }}
                active
              />
            </div>
          ))}
      </div>
    </div>
  );
}
